import { RESOURCES } from './content/common'
import { BANNERS } from './content/banners';
import { MISSIONS } from './content/missions'
import { ITEMS } from './content/items'
import { CHARACTERS, ENEMIES } from './content/characters'
import { CAMPAIGN_NODES } from './content/campaign'
import { BATTLES } from './content/battles'
import { ABILITIES } from './content/abilities';
import { CHAT_DATA1 } from './story/chatData1';
import { PLAYER } from './playerData';

const ELEMENTS = {};
const CHARACTER_TAGS = {};

export const instantiate = (original) => {
  return JSON.parse(JSON.stringify({
    ...original,
    uid: crypto.randomUUID()
  }))
}
export const CHATS = {
  chat1: CHAT_DATA1
};

PLAYER.unlockQueue = [];
PLAYER.powerups = {};

export const ACTIVE_BANNERS = BANNERS;

export { ELEMENTS, CHARACTER_TAGS, RESOURCES, MISSIONS, CAMPAIGN_NODES, CHARACTERS, ENEMIES, BATTLES, ABILITIES, ITEMS, PLAYER }
